var _g, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottlesGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 50,
    viewBox: "0 0 68 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_503_272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4332 17.6265V10H2.59403V17.6265C2.59403 19.0272 2.23087 20.428 1.50454 21.6213L1.08949 22.2957C0.363165 23.5927 0 24.9935 0 26.4462V50H9.02724V26.4462C9.02724 24.9935 8.66407 23.5927 7.93774 22.3476L7.5227 21.6732C6.79637 20.428 6.4332 19.0791 6.4332 17.6265Z",
    fill: "#B489A2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_503_272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.0415 9.53307V0H32.2425V9.53307C32.2425 11.284 31.7886 13.035 30.8807 14.5266L30.3619 15.3696C29.454 16.9909 29 18.7419 29 20.5577V50H40.284V20.5577C40.284 18.7419 39.8301 16.9909 38.9222 15.4345L38.4034 14.5914C37.4955 13.035 37.0415 11.3489 37.0415 9.53307Z",
    fill: "#B489A2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_503_272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.4332 17.6265V10H60.594V17.6265C60.594 19.0272 60.2309 20.428 59.5045 21.6213L59.0895 22.2957C58.3632 23.5927 58 24.9935 58 26.4462V50H67.0272V26.4462C67.0272 24.9935 66.6641 23.5927 65.9377 22.3476L65.5227 21.6732C64.7964 20.428 64.4332 19.0791 64.4332 17.6265Z",
    fill: "#B489A2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_503_272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.02724,
    height: 40,
    fill: "white",
    transform: "translate(0 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_503_272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.284,
    height: 50,
    fill: "white",
    transform: "translate(29)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_503_272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.02724,
    height: 40,
    fill: "white",
    transform: "translate(58 10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottlesGroup);
export default __webpack_public_path__ + "static/media/bottles-group.3eac8770.svg";
export { ForwardRef as ReactComponent };